import * as React from "react";
import {useCallback} from "react";
import {AppLauncherItem} from "./common";
import {classNames} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import {LauncherItem} from "@variocube/app-api";

interface LauncherProps {
    items: AppLauncherItem[];
    onLaunch: (appId: string, item?: LauncherItem) => void;
}

export function Launcher({items, onLaunch}: LauncherProps) {
    return (
        <div className={classNames(styles.launcher, items.length <= 3 && styles.launcherAppsCenter)}>
            {items.map(item => (
                <LauncherItemUi key={item.appId + item.id} item={item} onLaunch={onLaunch} />
            ))}
        </div>
    )
}

const styles = stylesheet(({
    launcher: {
        overflow: "auto",
        height: "100%",
        padding: "1.5em",
        display: "flex",
        flexFlow: "row wrap",
        justifyContent: "center",
    },
    launcherAppsCenter: {
        alignItems: "center",
    },
    app: {
        display: "block",
        margin: "1.5em",
        color: "#fff",
        flex: "1 1 0",
        minWidth: "12em",
        maxWidth: "15em",
        textAlign: "center",
        textShadow: "-1px 1px #000",
    },
    appIcon: {
        width: "75%",
        paddingTop: "75%", /* 1:1 Aspect Ratio */
        background: "no-repeat center center",
        backgroundSize: "75% auto",
        margin: "0 auto 0.5em auto",
        borderRadius: "50%",
        cursor: "pointer"
    },
    appName: {
        fontSize: "1.5em",
    }
}))

interface LauncherItemProps {
    onLaunch: (appId: string, item?: LauncherItem) => void;
    item: AppLauncherItem;
}

function LauncherItemUi({item, onLaunch}: LauncherItemProps) {
    const {appId, title, description, icon, color} = item;
    const handleClick = useCallback(() => onLaunch(appId, item), [onLaunch, appId]);
    return (
        <div className={styles.app} onClick={handleClick}>
            <div className={styles.appIcon}
                 style={{backgroundColor: color, backgroundImage: `url(${icon})`}}/>
            <div className={styles.appName}>{title}</div>
            <div className="desc">{description}</div>
        </div>
    );
}
